import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #SLIDER
\*------------------------------------ */
/**
 * 1) Slider is an input range that can have
 * 1 slider value, 2 slider values (range),
 */
:host {
  --thumb-size: calc(var(--size-base-unit) * 3);
  --tooltip-offset: 0.625rem;
  --track-height: 0.25rem;
}

/**
 * Container wrapping input and label
*/
.cat-c-slider__label-container {
  position: relative;
}

/**
 * Styling for default slider
*/
.cat-c-slider__input {
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-strong) 0%, var(--cat-theme-color-background-strong) 40%, var(--cat-theme-color-background-strong) 40%, var(--cat-theme-color-background-strong) 100%);
  position: absolute;
  border-radius: var(--cat-border-radius-lg);
  height: var(--track-height);
  width: 100%;
  outline: none;
  transition: background 450ms ease-in;
  appearance: none;
  margin: 0;
  border: 0;
  /**
    * WebKit specific styling
  */
  /**
    * Styling for track on slider
  */
  /**
    *Disabled state for track on slider
  */
  /**
  * Handle styling on slider
  */
  /**
  * Disabled state on handle on slider
  */
  /**
  * disabled Active state on handle
  */
  /**
  * Hover state on handle
  */
  /**
  * Focus state on handle
  */
  /**
  * Active state on handle
  */
  /**
  * Firefox specific styling
  */
  /**
  * Targets the progress track on the input slider
  */
  /**
  * Targets the track on the input slider
  */
  /**
  * Targets the handle on the input slider
  */
  /**
   * Applies hover state to the handle on the input slider
  */
  /**
   * Active state to the handle
  */
  /**
  * Applies focus state to the handle on the input slider
  */
  /**
  * Applies active state to the handle on the input slider
  */
}
.cat-c-slider__input::-webkit-slider-runnable-track {
  width: 100%;
  height: var(--track-height);
  border-radius: var(--cat-border-radius-lg);
  border: none;
}
.cat-c-slider__input:disabled::-webkit-slider-runnable-track {
  background-color: var(--cat-theme-color-background-disabled);
}
.cat-c-slider__input::-webkit-slider-thumb {
  border: 1px solid var(--cat-theme-color-background-xstrong);
  width: var(--thumb-size);
  height: var(--thumb-size);
  border-radius: 50%;
  background-color: var(--cat-theme-color-background-default);
  appearance: none;
  margin-block-start: calc(var(--thumb-size) / -2 + var(--track-height) / 2);
  cursor: grab;
  /**
  *  Styling and positiioning on thumb for dual range
  */
}
.cat-c-slider__range .cat-c-slider__input::-webkit-slider-thumb {
  position: relative;
  z-index: var(--cat-z-index-100);
  appearance: none;
  pointer-events: all;
}
.cat-c-slider__input:disabled::-webkit-slider-thumb {
  background-color: var(--cat-theme-color-background-disabled);
  border: 1px solid var(--cat-theme-color-border-disabled);
  cursor: not-allowed;
}
.cat-c-slider__input:disabled::-webkit-slider-thumb:active {
  outline: none;
}
.cat-c-slider__input:enabled::-webkit-slider-thumb:hover {
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.25);
}
.cat-c-slider__input:enabled:focus-visible::-webkit-slider-thumb {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-slider__input:enabled::-webkit-slider-thumb:active {
  background-color: var(--cat-theme-color-background-default);
  border: 2px solid var(--cat-theme-color-background-xstrong);
  cursor: grabbing;
  box-shadow: var(--cat-box-shadow-toggle);
}
.cat-c-slider__input.cat-c-slider-output-active::-webkit-slider-thumb {
  background-color: var(--cat-theme-color-background-default);
  border: 2px solid var(--cat-theme-color-background-xstrong);
  cursor: grabbing;
  outline: none;
}
.cat-c-slider__input::-moz-focus-outer {
  border: 0;
}
.cat-c-slider__input::-moz-range-progress {
  background-color: var(--cat-theme-color-background-brand);
  border-radius: var(--cat-border-radius-lg);
  height: var(--track-height);
}
.cat-c-slider__input::-moz-range-track {
  width: 100%;
  height: var(--track-height);
  background-color: var(--cat-theme-color-background-strong);
  border-radius: var(--cat-border-radius-lg);
  border: none;
}
.cat-c-slider__input:disabled::-moz-range-track {
  background-color: var(--cat-theme-color-background-disabled);
}
.cat-c-slider__input::-moz-range-thumb {
  height: var(--thumb-size);
  width: var(--thumb-size);
  border-radius: 50%;
  background-color: var(--cat-theme-color-background-default);
  border: 1px solid var(--cat-theme-color-background-xstrong);
  cursor: pointer;
}
.cat-c-slider__input:disabled::-moz-range-thumb {
  background-color: var(--cat-theme-color-background-disabled);
}
.cat-c-slider__input:enabled::-moz-range-thumb:hover {
  background-color: var(--cat-theme-color-background-default);
  border: 2px solid var(--cat-theme-color-background-xstrong);
}
.cat-c-slider__input:active::-moz-range-thumb {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-slider__input:enabled:focus-visible::-moz-range-thumb {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-slider__input:enabled::-moz-range-thumb:active {
  background-color: var(--cat-theme-color-background-default);
  border: 2px solid var(--cat-theme-color-background-xstrong);
  cursor: grabbing;
  outline: none;
}

/**
  * disabled state styling for range slider
  */
.cat-is-disabled {
  cursor: not-allowed;
}
.cat-is-disabled .cat-c-slider__range-color {
  background-color: var(--cat-theme-color-background-default-disabled);
}
.cat-is-disabled .cat-c-slider__range-input:disabled {
  background-color: var(--cat-theme-color-background-disabled);
}
.cat-is-disabled .cat-c-slider__range-input:disabled::-webkit-slider-thumb {
  background-color: var(--cat-theme-color-background-disabled);
  cursor: not-allowed;
  pointer-events: none;
  border: 1px solid var(--cat-theme-color-border-disabled);
}
.cat-is-disabled .cat-c-slider__range-input:disabled::-moz-range-thumb {
  background-color: var(--cat-theme-color-background-disabled);
}

/**
 * scss for loading variant
*/
.cat-is-loading {
  pointer-events: none;
}
.cat-is-loading .cat-c-slider__range-color {
  background-color: var(--cat-theme-color-background-default-disabled);
}
.cat-is-loading .cat-c-slider__range .cat-c-slider__range-two {
  background-color: var(--cat-theme-color-background-default-disabled);
}
.cat-is-loading .cat-c-slider__range .cat-c-slider__range-one::-webkit-slider-thumb,
.cat-is-loading .cat-c-slider__range .cat-c-slider__range-two::-webkit-slider-thumb {
  background-color: var(--cat-theme-color-background-disabled);
  pointer-events: none;
  border: 1px solid var(--cat-theme-color-border-disabled);
}
.cat-is-loading .cat-c-slider__range .cat-c-slider__range-one:enabled:focus-visible::-webkit-slider-thumb,
.cat-is-loading .cat-c-slider__range .cat-c-slider__range-two:enabled:focus-visible::-webkit-slider-thumb {
  border: none;
  outline: none;
  background-color: var(--cat-theme-color-background-disabled);
}
.cat-is-loading .cat-c-slider__range::-moz-range-thumb {
  background-color: var(--cat-theme-color-background-disabled);
  pointer-events: none;
  border: 1px solid var(--cat-theme-color-border-disabled);
}
.cat-is-loading .cat-c-slider__range-one-label-container,
.cat-is-loading .cat-c-slider__range-two-label-container {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * Hiding field note for loading state
*/
.cat-is-loading cat-field-note {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
 * scss for readonly variant
*/
.cat-is-readonly .cat-c-slider__input,
.cat-is-readonly .cat-c-slider__range-input {
  pointer-events: none;
}
.cat-is-readonly .cat-c-slider__input::-webkit-slider-thumb,
.cat-is-readonly .cat-c-slider__range-input::-webkit-slider-thumb {
  display: none;
}
.cat-is-readonly .cat-c-slider__input::-moz-range-thumb,
.cat-is-readonly .cat-c-slider__range-input::-moz-range-thumb {
  display: none;
}

/**
 * Slider range label that depicts current value
*/
.cat-c-slider__label-wrapper,
.cat-c-slider__range-one-label-container,
.cat-c-slider__range-two-label-container {
  position: absolute;
  inset-block-end: var(--cat-space-medium);
  text-align: start;
  overflow: visible;
  min-width: calc(var(--size-base-unit) * 3.75);
  width: max-content;
  z-index: var(--cat-z-index-top);
  background-color: var(--cat-theme-color-background-default);
  border-radius: var(--cat-border-radius-lg);
  color: var(--cat-theme-color-content-strong);
  box-shadow: var(--cat-theme-box-shadow-md);
  margin-block-end: calc(var(--size-base-unit) * 0.75);
  font-size: calc(var(--size-base-unit) * 1.5);
  line-height: calc(var(--size-base-unit) * 2);
}
.cat-c-slider__label-wrapper:after,
.cat-c-slider__range-one-label-container:after,
.cat-c-slider__range-two-label-container:after {
  content: "";
  display: block;
  position: absolute;
  inset-block-end: calc(-1 * var(--size-base-unit) * 1.25 / 2);
  inset-inline-start: calc(50% - var(--size-base-unit) * 1.25 / 2);
  background-color: var(--cat-theme-color-background-default);
  transform: rotate(45deg);
  width: calc(var(--size-base-unit) * 1.25);
  height: calc(var(--size-base-unit) * 1.25);
  box-shadow: var(--cat-theme-box-shadow-md);
}
.cat-c-slider__label-wrapper.cat-c-slider__range-lower-active-tooltip, .cat-c-slider__label-wrapper.cat-c-slider__range-upper-active-tooltip,
.cat-c-slider__range-one-label-container.cat-c-slider__range-lower-active-tooltip,
.cat-c-slider__range-one-label-container.cat-c-slider__range-upper-active-tooltip,
.cat-c-slider__range-two-label-container.cat-c-slider__range-lower-active-tooltip,
.cat-c-slider__range-two-label-container.cat-c-slider__range-upper-active-tooltip {
  z-index: calc(var(--cat-z-index-top) + 1);
}
.cat-is-loading .cat-c-slider__label-wrapper,
.cat-is-loading .cat-c-slider__range-one-label-container,
.cat-is-loading .cat-c-slider__range-two-label-container {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-slider__label,
.cat-c-slider__range-one-label,
.cat-c-slider__range-two-label {
  display: block;
  background-color: var(--cat-theme-color-background-default);
  border-radius: var(--cat-border-radius-lg);
  padding: calc(var(--size-base-unit) * 1);
  position: relative;
  z-index: var(--cat-z-index-top);
  text-align: center;
}
.cat-is-disabled .cat-c-slider__label,
.cat-is-disabled .cat-c-slider__range-one-label,
.cat-is-disabled .cat-c-slider__range-two-label {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}

/**
 * Applies flex to container to place input side by side
 */
.cat-c-slider__output-container,
.cat-c-slider__slot-container,
.cat-c-slider__range-container {
  display: flex;
  align-items: center;
  gap: var(--cat-space-medium);
  /**
  * Applies to make the slider as full width.
  */
}
.cat-c-slider__output-container .cat-c-slider__label-container,
.cat-c-slider__slot-container .cat-c-slider__label-container,
.cat-c-slider__range-container .cat-c-slider__label-container {
  flex: 1;
}

.cat-c-slider__range-container {
  min-height: calc(var(--size-base-unit) * 3);
}

.cat-c-slider__range-container .cat-c-slider--range {
  position: relative;
}

.cat-c-slider--output {
  display: flex;
  flex-direction: column;
}

/**
 * Double range slider container
*/
.cat-c-slider__range {
  position: relative;
  flex: 1 1 0%;
  /**
  * Input ranges for slider
  */
}
.cat-c-slider__range .cat-c-slider__range-one,
.cat-c-slider__range .cat-c-slider__range-two {
  position: absolute;
  appearance: none;
  width: 100%;
  height: var(--track-height);
  background-color: var(--cat-theme-color-background-strong);
  border-radius: var(--cat-border-radius-lg);
  margin: 0;
  border: 0;
  outline: none;
  pointer-events: none;
  /**
   * Thumb styling on dual range slider
  */
  /**
   * Thumb styling on focus state
  */
  /**
   * Applies hover state to the handle on the double range slider
  */
  /**
  * Active state on handle
  */
  /**
   * Thumb styling for firefox
  */
  /**
   * Thumb styling on focus state for firefox
  */
  /**
   * Applies hover state to the handle on the double range slider
  */
}
.cat-c-slider__range .cat-c-slider__range-one::-webkit-slider-thumb,
.cat-c-slider__range .cat-c-slider__range-two::-webkit-slider-thumb {
  position: relative;
  width: var(--thumb-size);
  height: var(--thumb-size);
  border-radius: 50%;
  background-color: var(--cat-theme-color-background-default);
  border: 1px solid var(--cat-theme-color-background-xstrong);
  z-index: var(--cat-z-index-200);
  cursor: pointer;
  appearance: none;
  pointer-events: all;
}
.cat-c-slider__range .cat-c-slider__range-one:enabled:focus-visible::-webkit-slider-thumb,
.cat-c-slider__range .cat-c-slider__range-two:enabled:focus-visible::-webkit-slider-thumb {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background-color: var(--cat-theme-color-background-default);
}
.cat-c-slider__range .cat-c-slider__range-one:enabled::-webkit-slider-thumb:hover,
.cat-c-slider__range .cat-c-slider__range-two:enabled::-webkit-slider-thumb:hover {
  box-shadow: var(--cat-box-shadow-toggle);
}
.cat-c-slider__range .cat-c-slider__range-one:enabled::-webkit-slider-thumb:active,
.cat-c-slider__range .cat-c-slider__range-two:enabled::-webkit-slider-thumb:active {
  background-color: var(--cat-theme-color-background-default);
  border: 2px solid var(--cat-theme-color-background-xstrong);
  box-shadow: var(--cat-box-shadow-toggle);
}
.cat-c-slider__range .cat-c-slider__range-one::-moz-range-thumb,
.cat-c-slider__range .cat-c-slider__range-two::-moz-range-thumb {
  position: relative;
  z-index: var(--cat-z-index-100);
  width: var(--thumb-size);
  height: var(--thumb-size);
  border-radius: 50%;
  background-color: var(--cat-theme-color-background-default);
  border: 1px solid var(--cat-theme-color-background-xstrong);
  appearance: none;
  pointer-events: all;
}
.cat-c-slider__range .cat-c-slider__range-one:enabled:focus-visible::-moz-range-thumb,
.cat-c-slider__range .cat-c-slider__range-two:enabled:focus-visible::-moz-range-thumb {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-slider__range .cat-c-slider__range-one:enabled::-moz-range-thumb:hover,
.cat-c-slider__range .cat-c-slider__range-two:enabled::-moz-range-thumb:hover {
  background-color: var(--cat-theme-color-background-default);
  border: 2px solid var(--cat-theme-color-background-xstrong);
}
.cat-c-slider__range .cat-c-slider__range-one::-ms-thumb,
.cat-c-slider__range .cat-c-slider__range-two::-ms-thumb {
  position: relative;
  z-index: var(--cat-z-index-200);
  width: var(--thumb-size);
  height: var(--thumb-size);
  border-radius: 50%;
  background-color: var(--cat-theme-color-background-default);
  border: 1px solid var(--cat-theme-color-background-xstrong);
  cursor: pointer;
  appearance: none;
  pointer-events: all;
}
.cat-c-slider__range .cat-c-slider__range-one::-ms-track,
.cat-c-slider__range .cat-c-slider__range-two::-ms-track {
  width: 100%;
  cursor: pointer;
  /* Hides the slider so custom styles can be added */
  background: transparent;
  border-color: transparent;
  color: transparent;
}
.cat-c-slider__range .cat-c-slider__range-one::-ms-fill-lower,
.cat-c-slider__range .cat-c-slider__range-two::-ms-fill-lower {
  background: var(--cat-theme-color-background-brand);
  border-radius: 50%;
}

.cat-c-slider__range-lower-active-thumb,
.cat-c-slider__range-upper-active-thumb {
  z-index: calc(var(--cat-z-index-300));
}

/**
 * Double range slider color span
*/
.cat-c-slider__range-color {
  position: absolute;
  display: block;
  z-index: var(--cat-z-index-100);
  width: 100%;
  height: 0.25rem;
  background-color: var(--cat-theme-color-background-brand);
  border-radius: var(--cat-border-radius-lg);
}

.cat-field-note--container,
.cat-error-note--container {
  display: block;
  margin-block-start: var(--cat-space-3x-small);
}

/**
  * Apply input styles to output variant input
  */
.cat-c-slider__output,
.cat-c-slider__output-range-one,
.cat-c-slider__output-range-two {
  width: calc(var(--size-base-unit) * 7);
  display: inline-block;
}
.cat-c-slider-warning .cat-c-slider__output, .cat-c-slider-error .cat-c-slider__output,
.cat-c-slider-warning .cat-c-slider__output-range-one,
.cat-c-slider-error .cat-c-slider__output-range-one,
.cat-c-slider-warning .cat-c-slider__output-range-two,
.cat-c-slider-error .cat-c-slider__output-range-two {
  width: calc(var(--size-base-unit) * 9.5);
}

/**
  * Apply styles to label / heading part
  */
.cat-c-slider-heading {
  display: inline-block;
  color: var(--cat-theme-color-background-xstrong);
  font-weight: var(--cat-font-weight-semibold);
  font-size: calc(var(--size-base-unit) * 1.75);
  line-height: calc(var(--size-base-unit) * 2.5);
  padding-block-end: var(--cat-space-medium);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1.25);
}
.cat-is-disabled .cat-c-slider-heading {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  pointer-events: none;
}
.cat-hidden-label .cat-c-slider-heading {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
  * Apply styles to before and after values (which displays min and max)
  */
.cat-c-slider-before-text,
.cat-c-slider-after-text {
  color: var(--cat-theme-color-background-xstrong);
}
.cat-is-disabled .cat-c-slider-before-text,
.cat-is-disabled .cat-c-slider-after-text {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-loading .cat-c-slider-before-text,
.cat-is-loading .cat-c-slider-after-text {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-slider-bottom-input-wrapper {
  padding-block-start: var(--cat-space-medium);
  display: flex;
  min-width: calc(var(--size-base-unit) * 15);
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
`;
       